import React, { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { Link, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { useFormik } from 'formik';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import Logo from '../../../components/Logo';
import useDarkMode from '../../../hooks/useDarkMode';
import Spinner from '../../../components/bootstrap/Spinner';
import { auth } from '../../../_services/user';
import Turnstile from '../../../components/Turnstile';
import { userAtom } from '../../../_atoms/user';
import { dashboardPagesMenu } from '../../../menu';
import showNotification from '../../../components/extras/showNotification';
import Icon from '../../../components/icon/Icon';
import { useTranslation } from 'react-i18next';
import { getLangWithKey } from '../../../lang';
import { APP_VERSION } from '../../../version'



const Login = () => {
	const [user, setUser] = useAtom(userAtom)
	const { darkModeStatus } = useDarkMode();

	const [captchaToken, setCaptchaToken] = useState('');
	const [captchaReset, setCaptchaReset] = useState(0);
	// 'disabled' | 'loading' | 'ready' | 'error'
	const [captchaStatus, setCaptchaStatus] = useState('loading');
	const [isLoading, setIsLoading] = useState(false);

	const { t } = useTranslation()

	const navigate = useNavigate();


	const LoginHeader = () => {
		return (
			<>
				<div className='text-center h1 fw-bold mt-5'>{t("login.welcome")}</div>
				<div className='text-center h4 text-muted mb-5'>{t("login.loginText")}</div>
			</>
		);
	};

	useEffect(() => {
		if (user.loggedIn) {
			navigate(`../${dashboardPagesMenu.dashboard.path}`);
		}
		return () => { };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			email: "",
			password: "",
		},
		validate: (values) => {
			const errors = {};

			if (!values.email) {
				errors.email = t("common.notEmpty");
			}

			if (!values.password) {
				errors.password = t("common.notEmpty");
			}

			return errors;
		},
		validateOnChange: false,
		onSubmit: (values) => {
			setIsLoading(true)
			const data = { email: values.email, password: values.password, captchaToken }
			auth(data)
				.then(res => {
					setIsLoading(false)
					if (res.data && res.data.code === 200) {
						setUser({ loggedIn: true, ...res.data.data, token: res.data.token })
						document.cookie = `token=${res.data.token};path=/`
					} else {
						// Sunucunun mesajı OLDUĞU GİBİ gösterilir. Önceden sabit bir metin
						// basılıyordu; bu yüzden hesap kilitlendiğinde kullanıcı
						// "15 dakika sonra deneyin" uyarısını hiç görmüyor, sebebi
						// anlamadan denemeye devam ediyordu.
						// Turnstile token'ı tek kullanımlıktır; yenilenmezse ikinci
						// deneme her zaman başarısız olur.
						setCaptchaReset(k => k + 1)
						formik.setFieldError('password', res.data?.message || t("login.passwordNotCorrect"));
					}
				})
				.catch(err => {
					setIsLoading(false)
					formik.setFieldError('password', t("common.error"));
				})
		},
	});

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	/**
	 * Giriş TEK ADIMDA yapılır: e-posta ve şifre birlikte gönderilir.
	 *
	 * Önceden iki adımlıydı: ilk adımda /paneluser/email ucuna sorulup hesabın
	 * kayıtlı olup olmadığı öğreniliyor, kayıtlı değilse "böyle bir kullanıcı
	 * yok" gösteriliyordu. Kullanıcı tespiti (user enumeration) zafiyetinin
	 * tam da kendisiydi. Sunucu tarafı kapatıldı; bu ekran da o akışa olan
	 * bağımlılıktan kurtarıldı.
	 */

	const { i18n } = useTranslation();

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng).then();
		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{t("common.langTitle", { lang: getLangWithKey(lng)?.text })}</span>
			</span>,
			t("common.langText"),
		);
	};

	return (
		<PageWrapper
			isProtected={false}
			title={t("common.login")}
			className='bg-dark'>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
						<Card className='shadow-3d-dark position-relative' data-tour='login-page'>
							{/* Sürüm package.json'dan üretilir (scripts/writeVersion.js) */}
							<span
								className='position-absolute text-muted'
								style={{ right: 12, top: 8, fontSize: 11, letterSpacing: 0.3 }}>
								v{APP_VERSION}
							</span>
							{/* <div className='col-auto justify-center' style={{ position: "absolute", right: 10, top: 10 }}>
								<Dropdown>
									<DropdownToggle hasIcon={false}>
										{typeof getLangWithKey(i18n.language)?.icon ===
											'undefined' ? (
											<Button
												// eslint-disable-next-line react/jsx-props-no-spreading
												{...styledBtn}
												className='btn-only-icon'
												aria-label='Change language'
												data-tour='lang-selector'>
												<Spinner isSmall inButton='onlyIcon' isGrow />
											</Button>
										) : (
											<Button
												// eslint-disable-next-line react/jsx-props-no-spreading
												{...styledBtn}
												icon={
													getLangWithKey(i18n.language)?.icon
												}
												aria-label='Change language'
												data-tour='lang-selector'
											/>
										)}
									</DropdownToggle>
									<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
										{Object.keys(LANG).map((i) => (
											<DropdownItem key={LANG[i].lng}>
												<Button
													icon={LANG[i].icon}
													onClick={() => changeLanguage(LANG[i].lng)}>
													{LANG[i].text}
												</Button>
											</DropdownItem>
										))}
									</DropdownMenu>
								</Dropdown>
							</div> */}
							<CardBody>
								<div className='text-center my-5'>
									<Link
										to='https://oxysuite.com'
										target='_blank'
										className={classNames(
											'text-decoration-none  fw-bold display-2',
											{
												'text-dark': !darkModeStatus,
												'text-light': darkModeStatus,
											},
										)}
										aria-label='Facit'>
										<Logo width={200} height={60} />
									</Link>
								</div>
								<LoginHeader />
								<form className='row g-4'>
									<>
											<div className='col-12'>
												<FormGroup
													id='email'
													isFloating
													label={t("common.email")}>
													<Input
														autoComplete='username'
														value={formik.values.email}
														isTouched={formik.touched.email}
														invalidFeedback={
															formik.errors.email
														}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}
														onKeyDown={(e) => {
															if (e.key === 'Enter' && captchaStatus !== 'loading') formik.handleSubmit();
														}}
													/>
												</FormGroup>
											</div>
											<div className='col-12'>
												<FormGroup
													id='password'
													isFloating
													label={t("common.password")}>
													<Input
														type='password'
														autoComplete='current-password'
														value={formik.values.password}
														isTouched={formik.touched.password}
														invalidFeedback={
															formik.errors.password
														}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onKeyDown={(e) => {
															if (e.key === 'Enter' && captchaStatus !== 'loading') formik.handleSubmit();
														}}
													/>
												</FormGroup>
											</div>
											<div className='col-12'>
												{/* Bot engelleme. Site key boşsa widget çizilmez
												    ve giriş normal çalışmaya devam eder. */}
												<Turnstile
													onToken={setCaptchaToken}
													onStatus={setCaptchaStatus}
													resetKey={captchaReset}
													theme={darkModeStatus ? 'dark' : 'light'}
												/>
											</div>
											<div className='col-12'>
												{/* Doğrulama sürerken giriş denenemez. Yalnızca 'loading'
												    durumunda kapatılır: site key yoksa ('disabled') veya
												    Cloudflare'a ulaşılamıyorsa ('error') düğme AÇIK kalır,
												    aksi hâlde panele hiç girilemezdi. */}
												<Button
													color='warning'
													className='w-100 py-3'
													isDisable={isLoading || captchaStatus === 'loading'}
													onClick={formik.handleSubmit}>
													{isLoading && (
														<Spinner isSmall inButton isGrow />
													)}
													{t("common.login")}
												</Button>
											</div>
										</>
								</form>
							</CardBody>
						</Card>
						{/* Gerçek sayfalara gider; önceki şablon bağlantıları '/' adresine
						    işaret ediyordu, yani çalışmıyorlardı. */}
						<div className='text-center'>
							<a
								href='https://oxyfitclub.com/gizlilik-politikasi'
								target='_blank'
								rel='noopener noreferrer'
								className='link-light text-decoration-none me-3'>
								{t('common.privacyPolicy')}
							</a>
							<a
								href='https://oxyfitclub.com/kullanim-kosullari'
								target='_blank'
								rel='noopener noreferrer'
								className='link-light text-decoration-none'>
								{t('common.termsOfUse')}
							</a>
						</div>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};
export default Login;
